import { Component, OnInit, Input } from '@angular/core';

import { Kpi } from '@classes/simulation/kpi';

@Component({
  selector: 'app-gauge-double',
  templateUrl: './gauge-double.component.html',
  styleUrls: ['./gauge-double.component.scss']
})
export class GaugeDoubleComponent implements OnInit {
    @Input() kpis: Kpi[];
    @Input() year: number;
    @Input() isEstimated: boolean;
    @Input() isAlone: boolean;

    maxNumber = 2;

    constructor( ) { }

    ngOnInit() {
    }

    formatShowedState(isEstimated: boolean): string {
        return isEstimated ? 'dashboard.simulator.yearStates.projected.shortLabel' : 'dashboard.simulator.yearStates.executed.shortLabel';
    }
}
